import React, { useContext } from 'react';
import { MFContext } from '@4r/mf-host';
import { AccessContext } from '@4r/module-common-authorization';

const VendorExp: React.FC = () => {
	const { VendorExpMicrofrontend } = useContext(MFContext);
	const { user } = useContext(AccessContext);

	if (!VendorExpMicrofrontend || !user) return null;

	// Legacy offline removal: vendor-exp loads its own order data via
	// `@4r/common-module-offline-services` (`useOrders`), so the host no longer
	// injects `ordersData` / `refreshOrdersData` / `isLoading` from the legacy
	// `OfflineOrderContext`.
	return <VendorExpMicrofrontend currentUser={user} offlineMode="full" />;
};

export default VendorExp;
